import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { Check } from "lucide-react";

function SectionHeading({ eyebrow, title, subtitle, dark }) {
  return (
    <div className="max-w-2xl">
      <div className="flex items-center gap-3 mb-4">
        <span className="section-line" />
        <span className={`text-xs font-700 uppercase tracking-[0.25em] font-display ${dark ? "text-[#f5871f]" : "text-[#f5871f]"}`}>
          {eyebrow}
        </span>
      </div>
      <h2 className={`font-display font-700 text-4xl md:text-5xl uppercase leading-tight ${dark ? "text-white" : "text-[#0d2140]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed ${dark ? "text-white/60" : "text-[#0d2140]/60"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export { SectionHeading };

export default function Services() {
  const { t } = useLang();
  const s = t.services;
  const ref = useReveal();

  return (
    <section id="servicios" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} subtitle={s.subtitle} />

        <div ref={ref} className="reveal mt-14 grid md:grid-cols-3 gap-8">
          {s.items.map((item, i) => (
            <div key={i} className="card-hover bg-white rounded-2xl border border-[#0d2140]/10 overflow-hidden">
              <div className="relative h-52">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" />
                <span className="absolute top-4 left-4 bg-[#f5871f] text-white text-xs font-700 uppercase tracking-wider px-3 py-1 rounded-full font-display">
                  {item.tag}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display font-700 text-xl uppercase text-[#0d2140]">{item.title}</h3>
                <p className="text-[#0d2140]/60 text-sm mt-2 leading-relaxed">{item.text}</p>
                <ul className="mt-4 space-y-2">
                  {item.points.map((p, j) => (
                    <li key={j} className="flex items-center gap-2 text-sm text-[#0d2140]/80">
                      <Check className="w-4 h-4 text-[#f5871f] shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
